import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { WalletInfo } from 'src/app/core/models/wallet-info.model';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from "src/app/core/services/storage.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { API } from './../../../../core/constants';
import { AppService } from "src/app/core/services/app.service";
import { environment } from "src/environments/environment";
import { WalletConnectDialogComponent } from "src/app/pages/components/wallet-connect-dialog/wallet-connect-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Web3Service } from "src/app/core/services/web3.service";
@Component({
  selector: "app-left-side-menu",
  templateUrl: "./left-side-menu.component.html",
  styleUrls: ["./left-side-menu.component.scss"],
})
export class LeftSideMenuComponent implements OnInit {
  isCryptoWallet= environment.clientDetails.required_crypto_wallet;
  menuList: any;
  dashboardList: any;
  profile_type: any;
  profile = false;
  module: string;
  show: boolean = false;
  showdropdownbox: boolean = false;
  subscriptionLeftTabMenuActive: Subscription;
  loggedIn: boolean = false;

  userInfo: any = {};
  userInfoSubscription: Subscription;
  routerevents: Subscription;
  displayName: "";
  profileName: "";
  currentLocation: {};
  getCurrency: any;
  walletID : string;
  available_balance : any;
  crypto_balance: Number;
  cryptoAmount : any;
  cryptoSymbol: string;

  get channelName(): string { return this.router.url.split('/')[1] || ''; }
  constructor(public router: Router, private toastr: ToastrService,
    private commanSubscribeService: CommanSubscribeService,
    public route: ActivatedRoute, private storageService: StorageService,private web3service: Web3Service,
    private ngxLoader: NgxUiLoaderService, private appService: AppService, public dialog: MatDialog) {
    this.commanSubscribeService.walletInfoSubject.subscribe(
      result => {
        if (result?.organizationId === this.commanSubscribeService.orgId) {
          this.walletInfo = result.wallet;
        }
      }
    )
    if (this.menuList) {
      this.menuList.forEach((val) => {
        if (this.router.url.includes(val.name.toLowerCase())) {

          val.activeMenu = true;
        } else {
          val.activeMenu = false;
        }
        if (val.sub_menu.length > 0) {
          val.sub_menu.forEach(sublist => {
            sublist.subMenuActive = true;
            if (this.router.url.includes(sublist.menu_name.toLowerCase())) {
              sublist.subMenuActive = true;
            } else {
              sublist.subMenuActive = false;
            }
          });
        }
      });
    }
    this.routerevents = router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this.route && this.route.firstChild && this.route.firstChild.paramMap) {
          this.route.firstChild.paramMap.subscribe(
            (params: any): void => {
              let eventId;
              // this.slug_name = this.slugInfo && this.slugInfo.slug ? this.slugInfo.slug : params.params['slug_name'];
              if (this.menuList) {
                this.menuList.forEach((val) => {
                  val.activeMenuList = false;
                  if (this.router.url.includes(val.name.toLowerCase())) {

                    val.activeMenu = true;
                  } else {
                    val.activeMenu = false;
                  }
                  if (val.sub_menu.length > 0) {
                    val.sub_menu.forEach(sublist => {
                      sublist.subMenuActive = true;
                      if (this.router.url.includes(sublist.link) || (sublist.menu_name == 'Order History' && this.router.url.includes('/user-dashboard/order-details/'))) {
                        sublist.subMenuActive = true;
                        val.activeMenuList = true;
                      } else {
                        sublist.subMenuActive = false;
                      }
                    });
                  }
                });
              }
            }
          );
        }
      }
    });
    if (this.router.url && this.router.url.indexOf("user-dashboard") != -1) {
      this.module = "user-dashboard";
    } else if (this.router.url && this.router.url.indexOf("user") != -1) {
      this.module = "user";
    }
    this.subscriptionLeftTabMenuActive = this.commanSubscribeService.getLeftTabActiveBasedOnRouterURL().subscribe(message => {
      setTimeout(() => {
        if (!this.subMenu)
          this.leftSideActive();
      }, 2000);
    });
  }

  ngOnInit() {
    this.web3service.connectedAccId.subscribe(walletId => this.walletID = walletId);
    console.log(">>>>",this.walletID);
    this.commanSubscribeService.getAccountBalance(this.walletID);
    this.cryptoSymbol = environment.clientDetails.crypto_symbol;
    this.cryptoAmount = this.commanSubscribeService.getCryptoBalance().subscribe((result)=>{
      this.available_balance = result.available_balance;
      this.available_balance > 0 ? this.crypto_balance = result.crypto_balance : 0;
    })

    if (this.module === "user-dashboard") {
      const ch = this.channelName === 'user-dashboard' ? '' : this.channelName;
      const udBase = ch ? `/${ch}/user-dashboard` : '/user-dashboard';
      this.menuList = [


        {
          icon: "fa fa-user menu-icon",
          name: "My Profile",
          flag: "true",
          sub_menu: [
            {
              menu_name: "Basic info",
              type: "basic-info",
              link: `${udBase}/profile-settings/basic-info`
            },
            {
              menu_name: "Change Password",
              type: "change-password",
              link: `${udBase}/profile-settings/change-password`
            },
            // {
            //   menu_name: "Payment Methods",
            //   type: "payment-methods",
            //   link: "user-dashboard/payment-methods"
            // },
            {
              menu_name: "My Address",
              type: "my-address",
              link: `${udBase}/my-address`

            },
            // {
            //   menu_name: "Subscribed Channels",
            //   type: "subscribed-channel",
            //   link: "user-dashboard/subscribed-channel"
            // },
            // {
            //   menu_name: "My Purchases",
            //   type: "my-purchases",
            //   link: "user-dashboard/my-purchases"
            // },
            // {
            //   menu_name: "Order History",
            //   type: "order-history",
            //   link: "user-dashboard/order-history"
            // },
          ]
        },

        // Saved videos and playlists; same entry as the network header's profile menu. Needs a network in the URL.
        {
          icon: "fa fa-bookmark menu-icon",
          name: "My Library",
          link: ch ? `${this.commanSubscribeService.getChannelBasePath(ch)}/my-library` : '',
          sub_menu: [],
          hide: !ch,
        },
        {
          icon: "fa fa-calendar-check-o menu-icon",
          name: "My Events",
          flag: "true",
          sub_menu: [

            {
              menu_name: "Live",
              type: "live_events",
              link: `${udBase}/My-events`
            },
            {
              menu_name: "Upcoming",
              type: "upcoming_events",
              link: `${udBase}/My-UpcomingEvents`
            },
            {
              menu_name: "Past",
              type: "past_events",
              link: `${udBase}/My-PastEvents`
            },

          ]
        },
        {
          icon: "fa fa-calendar-check-o menu-icon",
          name: "My Payments",
          flag: "true",
          sub_menu: [

            {
              menu_name: "Payment Methods",
              type: "payment-methods",
              link: `${udBase}/payment-methods`
            },
            {
              menu_name: "Subscribed Channels",
              type: "subscribed-channel",
              link: `${udBase}/subscribed-channel`
            },
            {
              menu_name: "My Purchases",
              type: "my-purchases",
              link: `${udBase}/my-purchases`
            },
            {
              menu_name: "Order History",
              type: "order-history",
              link: `${udBase}/order-history`
            },
            {
              //   icon: "fa fa-handshake-o menu-icon mr-10",
              menu_name: "Tips/Donations",
              type: "donation-tip",
              link: `${udBase}/tips-donations`,
            },
          ]
        },
        {
          icon: "fa fa-heart menu-icon ml-5",
            name: "My Wishlist",
            link: `${udBase}/My_WishList`,
            sub_menu: []
        },
        {
          icon: "fa fa-info-circle menu-icon ml-10",
          name: "Crypto Instructions",
          link: `${udBase}/crypto-instructions`,
          sub_menu: [],
          hide:environment.clientDetails.required_crypto_wallet===0,
        },
        // ...(environment.clientDetails.required_crypto_wallet === 1 ? [{
        //   icon: "fa fa-th-large menu-icon",
        //   name: "MY NFTs",
        //   link: "",
        //   sub_menu: [],
        // }] : []),
        // {
        //   icon: "fa fa-heart menu-icon",
        //   name: "My Wishlist",
        //   link: "",
        //   sub_menu: [

        //     {

        //     },
        //   ]
        // },
        // {
        //   icon: "fa fa-shopping-cart menu-icon",
        //   name: "My Cart",
        //   link: "",
        //   sub_menu: [
        //     {
        //       menu_name: "NFTs",
        //       type: "order-history",
        //       link: ""
        //     },
        //     {
        //       menu_name: "Merchandise",
        //       type: "donation-tip",
        //       link: "",
        //     },
        //   ]
        // },
      ];

    } else if (this.module === "user") {
      this.menuList = [
        {
          icon: "fa fa-th-large menu-icon mr-10",
          name: "Home",
          link: "/Smith-Jane/12/live",
        },
        {
          icon: "fa fa-user menu-icon mr-10",
          name: "Profile",
          link: "/Smith-Jane/12/profile",
        },
        {
          icon: "fa fa-calendar menu-icon mr-10",
          name: "Upcoming",
          link: "/Smith-Jane/12/upcoming-events",
        },
        {
          icon: "fa fa-video-camera menu-icon mr-10",
          name: "Videos",
          link: "/Smith-Jane/12/videos",
        },
        {
          icon: "fa fa-file-audio-o menu-icon mr-10",
          name: "Audios",
          link: "/Smith-Jane/12/audios",
        },
        {
          icon: "fa fa-users menu-icon mr-10",
          name: "Followers",
          link: "/Smith-Jane/12/followers",
        },
      ];
    }

    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        let localCur = this.currentLocation && Object.keys(this.currentLocation).length > 0 ? this.currentLocation["currency"]["code"] : '';
        this.getCurrency = this.getCurrency ? this.getCurrency : localCur;
      });
    }else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      let localCur = this.currentLocation && Object.keys(this.currentLocation).length > 0 ? this.currentLocation["currency"]["code"] : '';
      this.getCurrency = this.getCurrency ? this.getCurrency : localCur;
    }
    this.getCurrency = this.storageService.getItem('currency');

    this.userInfo = this.commanSubscribeService.userInfo;
    this.getName();
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.getName();
      let userInfo = this.storageService.getItem('user_Info');
      if (userInfo && userInfo.access_token && this.userInfo && this.userInfo.id) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    });

    if (this.userInfo && this.userInfo.id) {
      this.getAvailBalance();
    }

    this.goToMenu(this.router.url, null);
    // this.subscriptionLeftTabMenuActive = this.commanSubscribeService.getLeftTabActiveBasedOnRouterURL().subscribe(message => {
    //   setTimeout(() => {
    //     this.leftSideActive();
    //   }, 2000);
    // });
  }



  connectToWallet(){
    this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
      if (isweb3 === 'connected') {
    this.web3service.connectAccount().then((res) => {
      this.walletID = res;
      this.web3service.setContract();
      this.commanSubscribeService.getAccountBalance(this.walletID);
    })
    console.log("wallet id",this.walletID);
  }
  }).catch((e)=>{
    this.dialog.open(WalletConnectDialogComponent,{
      // backdropClass:'blurred',
      // disableClose: true,
      panelClass : "app-consumer-sign-in",  
      hasBackdrop : true
    });
  })
  }


  walletInfo: WalletInfo;
  getAvailBalance() {
    this.walletInfo = this.commanSubscribeService.walletByOrg[this.commanSubscribeService.orgId];
    if (!this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.commanSubscribeService.getAvailBalance(result => {
        this.walletInfo = result;
      }, this.commanSubscribeService.orgId);
    }
  }


  

  
  goToMenu(link, menu?) {

    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed && menu && 
    //   link.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info'); 
    //   return;
    // }

    this.menuList = this.commanSubscribeService.getFilterMenu(this.menuList, link, menu);
    if (link) {
      this.router.navigateByUrl(link);
    } else if (menu) {
      let obj = this.menuList.filter(m => m.name == menu.name)[0];
      this.router.navigateByUrl(obj.sub_menu[0].link);
    }
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL('');
  }

  signout() {
    this.storageService.deleteItem('eventInfo');
    this.storageService.deleteItem('isEvent');
    this.storageService.deleteItem('ticket_key');
    this.ngxLoader.start();
    this.appService.postRequest(API.FAN_LOGOUT,"").subscribe(result => {
      this.ngxLoader.stop();
      if (result["status"] == 0) {
        this.ngxLoader.stop();
        this.loggedIn = false;
         localStorage.isFanLoginUser =false;
        // this.storageService.deleteItem("userInfo");
        this.storageService.deleteItem("isAffiliateUser");
        this.storageService.deleteItem("user_Info");
        this.storageService.deleteItem("eventInfo");
        this.commanSubscribeService.sendTriggeredEvent({ actionType: 'sign-out', actionName: 'USER_LOGOUT', organizationId: this.commanSubscribeService.orgId || null });
        this.commanSubscribeService.sendUserInfo({});
        this.commanSubscribeService.sendMylistData([]);
        this.userInfo = {};
        this.web3service.signout();
     
        
        this.storageService.deleteItem("signInRouteData");
        sessionStorage.removeItem('oidcAttempted');
        this.storageService.deleteItem("redirectUrlAfterGoogleLogin");
        // Step 3: Trigger OneLogin logout (OIDC)
          const ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;//environment.onelogin_domain;
          const POST_LOGOUT_REDIRECT_URI = environment.social_auth_redirect_uri;
          // const POST_LOGOUT_REDIRECT_URI = "http://localhost:4200/";
          const ID_TOKEN = localStorage.getItem("id_token");

          if (ID_TOKEN) {
            const formattedIdToken = ID_TOKEN.replace(/^"|"$/g, ""); // remove extra quotes
            const logoutUrl =
              `https://${ONELOGIN_DOMAIN}/oidc/2/logout` +
              `?id_token_hint=${encodeURIComponent(formattedIdToken)}` +
              `&post_logout_redirect_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`;

            window.location.href = logoutUrl; // redirect to OneLogin logout page
          } else {
            localStorage.clear();
            this.router.navigateByUrl('/' + this.channelName);
          }


      } else{
        this.ngxLoader.stop();
        this.toastr.error(result["message"]);
      }
      // this.message = result.message;
    }, error => {
      this.ngxLoader.stop();
      console.log(error);
    });

  }
  profile_pic = '';
  getName() {
    if (this.userInfo) {

      if (this.userInfo.user_display_name) {
        this.profile_pic = this.userInfo.profile_pic ? this.userInfo.profile_pic : ""
        let name;
        if (this.userInfo.user_display_name && this.userInfo.user_display_name.includes(' ')) {
          name = this.userInfo.user_display_name.split(' ');
          if (name[0] && !name[1] && name[1] != '') {
            this.displayName = name[0][0] + name[0][1];
          } else if (name[1][0] != undefined) {
            this.displayName = name[0][0] + (name[2] ? name[2][0] : name[1][0]);
          } else {
            this.displayName = this.userInfo.user_display_name[0];
          }
        } else if (this.userInfo.user_display_name[1] != undefined) {
          this.displayName = this.userInfo.user_display_name[0] + this.userInfo.user_display_name[1];
        } else {
          this.displayName = this.userInfo.user_display_name[0];
        }
        // this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_last_name[0];
        this.profileName = this.userInfo.user_display_name;
        // this.profileName = this.userInfo.user_first_name + " " + this.userInfo.user_last_name;
      } else if (this.userInfo.user_first_name) {
        this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_first_name[1];
        this.profileName = this.userInfo.user_first_name;
      } else if (this.userInfo.user_email) {
        this.displayName = this.userInfo.user_email[0] + this.userInfo.user_email[1];
      }
    }
  }
  subMenu = false;
  navigateSubmenu(data) {
    this.subMenu = true;
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed && 
    //   data.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   return;
    // }

    this.menuList = this.commanSubscribeService.getFilterMenu(this.menuList, data, 'subMenu');
    this.router.navigateByUrl(data);
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL('');
  }

  leftSideActive() {
    this.menuList = this.commanSubscribeService.getFilterMenu(this.menuList, this.router.url, 'allMenu');
  }

  ngOnDestroy() {
    if (this.subscriptionLeftTabMenuActive) {
      this.subscriptionLeftTabMenuActive.unsubscribe();
    }
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if(this.cryptoAmount){
      this.cryptoAmount.unsubscribe();
    }
  }
  Showdropdown() {
    this.showdropdownbox = true;
    this.show = true;
  }

  toggleMenuList(list: any) {
    list.activeMenuList = !list.activeMenuList;
  }
}
